import { render, staticRenderFns } from "./nft-card.vue?vue&type=template&id=b40ba2de&"
import script from "./nft-card.vue?vue&type=script&lang=js&"
export * from "./nft-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports